import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { icons } from './icons';

export interface IconPickerData {
  icon: string;
}

@Component({
  selector: 'xui-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
]
})
export class IconPickerComponent implements OnInit, OnDestroy {
  private formBuilder = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<IconPickerComponent>);
  private data: IconPickerData = inject(MAT_DIALOG_DATA);

  selectedIcon = '';
  form!: FormGroup;
  icons: string[] = [];
  private formSubscription?: Subscription;
  private selectedIconIndex = 0;

  get unfilteredIcons(): string[] {
    if (this.selectedIconIndex > 0) {
      const start = Math.max(0, this.selectedIconIndex - 50);
      const end = Math.min(icons.length, this.selectedIconIndex + 50);
      return icons.slice(start, end);
    }
    return icons.slice(0, 100);
  }

  ngOnInit() {
    if (this.data && this.data.icon) {
      this.selectedIcon = this.data.icon;
      this.selectedIconIndex = icons.indexOf(this.selectedIcon);
    }
    this.icons = this.unfilteredIcons;
    this.form = this.formBuilder.group({
      query: ['']
    });
    this.formSubscription = this.form.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
      if (!value.query || value.query === '') {
        this.icons = this.unfilteredIcons;
        return;
      }
      this.icons = icons.filter(icon => icon.includes(value.query));
    });
  }

  ngOnDestroy() {
    this.formSubscription?.unsubscribe();
  }

  selectIcon(icon: string) {
    this.selectedIcon = icon;
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({ icon: this.selectedIcon });
  }
}
